import { TextFormField } from 'types';
import { RichTextPreview } from 'components/rich-text-preview';

export const FormText = ({ text }: TextFormField) => (
  <section className="col-span-full w-full py-2">
    <RichTextPreview content={text} allowImages={false} />
  </section>
);
